(function ($) {
    'use strict';

    var FORM_SEND_API_URL = '/:lang/api/forms/:id/send';

    var $html = $('html');
    var $body = $('body');

    var AdminForms = {};

    AdminForms.getFormSendUrl =  function (id) {
        return FORM_SEND_API_URL
            .replace(':lang', $html.attr('lang'))
            .replace(':id', id)
        ;
    };

    AdminForms.onSubmitSendForm = function (event) {
        event.preventDefault();

        var $form = $(this),
            $modal = $form.closest('.modal'),
            $successAlert = $('#forms-index-success-message-alert'),
            $errorAlert = $('#forms-index-error-message-alert'),
            serializedArray = $form.serializeArray(),
            data = {};

        for (var i = 0; i < serializedArray.length; i++) {
            data[serializedArray[i].name] = serializedArray[i].value;
        }

        if (! data.formId) {
            return false;
        }

        var apiUrl = AdminForms.getFormSendUrl(data.formId);

        $form.data('admin-forms.state', 'loading');
        $form.addClass('is-loading');

        $.ajax(apiUrl, {
            method: 'POST',
            data: {
                'email' : data.email || null
            }
        })
            .done(function(data) {
                if (! data.ok) {
                    $successAlert.addClass('u-is-hidden');
                    $errorAlert.find('[data-message]').text(data.error);
                    $errorAlert.removeClass('u-is-hidden');
                    return;
                }

                $errorAlert.addClass('u-is-hidden');
                $successAlert.find('[data-message]').text(data.message);
                $successAlert.removeClass('u-is-hidden');

                return true;
            })
            .always(function () {
                $modal.modal('hide');

                $form.data('admin-forms.state', null);
                $form.removeClass('is-loading');
            })
        ;
    };

    $(document).ready(function () {
        $body.on('submit.admin-forms', '#adminSendModal form', AdminForms.onSubmitSendForm);
    });

})(require('jquery'));
